<template>
    <div>
        <div class="modal-header">
            <logo />
            <div class="actions">
                <div v-if="hasLocaleSwitcher">
                    <selector-locale class="same-line" />
                </div>
                <div>
                    <button
                        v-if="hasCloseListener"
                        type="button"
                        aria-label="Close"
                        class="same-line close"
                        @click="$emit('close')"
                    >
                        <span aria-hidden="true">
                            ×
                        </span>
                    </button>
                </div>
            </div>
        </div>
        <div class="modal-body">
            <slot />
        </div>
        <div class="modal-footer">
            <slot name="footer" />
        </div>
    </div>
</template>

<script>
const SelectorLocale = () => ({
    component: import(/* webpackMode: "eager", webpackChunkName: "selector-locale" */ process
        .env.VUE_APP_LOCALESELECTOR_TYPE === "FlagLocaleSelector"
        ? "@/components/selectors/SelectorLocaleFlag"
        : "@/components/selectors/SelectorLocaleText")
});

export default {
    components: {
        SelectorLocale
    },
    computed: {
        hasCloseListener() {
            // We only show the close button if the close event is being listened on
            return this.$listeners && this.$listeners.close;
        },
        hasLocaleSwitcher() {
            return (
                JSON.parse(process.env.VUE_APP_AVAILABLE_LANGUAGES).length > 1
            );
        }
    }
};
</script>

<style>
.modal-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 15px;
    border-bottom: 1px solid rgb(229, 229, 229);
}

.modal-header .logo {
    max-height: 55px;
}

.modal-header .actions {
    display: flex;
    align-items: center;
}

.modal-header .close {
    font-size: 21px;
    font-weight: 700;
    color: #000;
    text-shadow: 0 1px 0 #fff;
    filter: alpha(opacity=50);
    opacity: 0.4;
    margin-left: 10px;
    appearance: none;
    padding: 0;
    cursor: pointer;
    background: 0 0;
    border: 0;
}

.modal-body,
.modal-footer {
    position: relative;
    padding: 15px;
}

.horizontal-spacer {
    margin-left: 0.5em;
    margin-right: 0.5em;
}

.same-line {
    display: inline-block;
}
</style>
